var _excluded = ["checkboxLabel", "className", "onChange", "value"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import FormGroup from '../Form/FormGroup';
import Input from '../Input/Input';
import Label from '../Label/Label';
var count = 0;

function getID() {
  return `checkbox-boolean-input-${count++}`;
}

class CheckboxBooleanInput extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "id", getID());

    this.id = props.id || this.id;
  }

  render() {
    var _this$props = this.props,
        checkboxLabel = _this$props.checkboxLabel,
        className = _this$props.className,
        _onChange = _this$props.onChange,
        value = _this$props.value,
        inputProps = _objectWithoutProperties(_this$props, _excluded);

    var classNames = classnames('pt-2', className);
    return /*#__PURE__*/React.createElement(FormGroup, {
      check: true,
      className: classNames
    }, /*#__PURE__*/React.createElement(Input, _extends({
      id: this.id
    }, inputProps, {
      type: "checkbox",
      checked: value,
      onChange: e => _onChange && _onChange(e.target.checked)
    })), checkboxLabel && /*#__PURE__*/React.createElement(Label, {
      check: true,
      for: this.id
    }, checkboxLabel));
  }

}

_defineProperty(CheckboxBooleanInput, "propTypes", {
  id: PropTypes.string,
  checkboxLabel: PropTypes.node,
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool
});

CheckboxBooleanInput.displayName = "CheckboxBooleanInput";
export default CheckboxBooleanInput;